import React from "react"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// https://fkhadra.github.io/react-toastify/introduction

const SetupToastContainer = () => <ToastContainer />

export default SetupToastContainer
